export const createActivityLog = `
    mutation createActivityLog($input: CreateActivityLogInput!) {
        createActivityLog(input:$input) {
            id
            username
            usageType
            value
            action
            recordId
            recordType
            created
    }
}`;

export const updateActivityLog = `
    mutation updateActivityLog($input: UpdateActivityLogInput!) {
        updateActivityLog(input:$input){
            id
            username
            usageType
            value
            action
            recordId
            recordType
            created
        }
}`;

export const deleteActivityLog = `
    mutation deleteActivityLog($input: DeleteActivityLogInput!) {
        deleteActivityLog(input:$input) 
}`;
